module.exports = __webpack_public_path__ + "img/icon_credit-card.53276869.svg";